// extracted by mini-css-extract-plugin
module.exports = {"tariffItemCol":"PageSubscription__tariffItemCol___BHgE","successStateBtn":"PageSubscription__successStateBtn__CpJF3"};